
import {Component, Prop} from "vue-property-decorator";
import {HcPageModel} from "@dev/hc-components";
import IOrderItem from "@/module/main/model/applicationForm/IOrderItem";
import ICurrency from "@/module/main/dto/ICurrency";
import {EnumUtil} from "@/app";
import OrderItemType from "@/module/main/dto/customer/OrderItemTypeEnum";

@Component({
    components: {}
})
export default class OrderItem extends HcPageModel
{
    @Prop({type: Object}) public value!: IOrderItem;
    @Prop({type: Number}) public sequence!: number;
    @Prop({type: Object}) public currency!: ICurrency;

    protected pageName: string = "order-item";

    protected inputId(code: string): string | null
    {
        return `${this.sequence}-${this.pageName}-${code}`;
    }

    private get supportedTypesString(): string
    {
        return "image/png image/jpg";
    }

    private get orderItemTypeData(): object[]
    {
        return EnumUtil.createSelectDataFromEnum(OrderItemType, "OrderItemType", true);
    }

    private async onChangeInput(event: Event)
    {
        let files = (event.target as HTMLInputElement).files;
        if (files && files.length > 0)
        {
            this.value.image = await this.convertFileToBase64(files[0]);
            this.value.imageFileName = files[0].name;
        }
    }

    private convertFileToBase64(file: File): Promise<string>
    {
        return new Promise((resolve, reject) =>
        {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve((reader.result?.toString() || '').split(',')[1]);
            reader.onerror = reject;
        });
    }
}
